<template>
  <div class="tp-course-item p-relative fix mb-30" :class="cssClass" :style="cssStyle">
    <div class="tp-course-teacher mb-15">
      <span v-if="course.instructor?.name"><img :src="(course.instructor.user_image)?course.instructor.user_image:'/assets/lms_website/images/user.png'" alt=""/>
        {{ course.instructor?.full_name }}
      </span>
    </div>
    <div class="tp-course-thumb">
      <router-link :to="`/courses/view/${course.name}`">
        <img class="course-sky" :src="(course.image)?course.image:'/assets/lms_website/images/placeholder.jpg'" :alt="lms_website.__(course.title)"/>
      </router-link>
    </div>
    <div class="tp-course-content">
      <div class="tp-course-tag mb-10">
        <span>{{ lms_website.__(course.tags) }}</span>
      </div>
      <div class="tp-course-meta">
        <span>
           <span>
              <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path
                     d="M13.9228 10.0426V2.29411C13.9228 1.51825 13.2949 0.953997 12.5252 1.01445H12.4847C11.1276 1.12529 9.07163 1.82055 7.91706 2.53596L7.80567 2.6065C7.62337 2.71733 7.30935 2.71733 7.11692 2.6065L6.9549 2.50573C5.81046 1.79033 3.75452 1.1152 2.3974 1.00437C1.62768 0.943911 0.999756 1.51827 0.999756 2.28405V10.0426C0.999756 10.6573 1.50613 11.2417 2.12393 11.3122L2.30622 11.3425C3.70386 11.5238 5.87126 12.2392 7.10685 12.9143L7.1372 12.9244C7.30937 13.0252 7.59293 13.0252 7.75498 12.9244C8.99057 12.2393 11.1681 11.5339 12.5758 11.3425L12.7885 11.3122C13.4164 11.2417 13.9228 10.6674 13.9228 10.0426Z"
                     stroke="#94928E"
                     stroke-width="1.2"
                     stroke-linecap="round"
                     stroke-linejoin="round"
                 />
                 <path d="M7.46118 2.81787V12.4506" stroke="#94928E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
           </span>
           {{ course.lesson_count }}  {{ lms_website.__('Lessons') }}
        </span>
        <span>
           <span>
              <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path
                     d="M6.57134 7.5C8.36239 7.5 9.81432 6.04493 9.81432 4.25C9.81432 2.45507 8.36239 1 6.57134 1C4.7803 1 3.32837 2.45507 3.32837 4.25C3.32837 6.04493 4.7803 7.5 6.57134 7.5Z"
                     stroke="#94928E"
                     stroke-width="1.2"
                     stroke-linecap="round"
                     stroke-linejoin="round"
                 />
                 <path
                     d="M12.1426 14C12.1426 11.4845 9.64553 9.44995 6.57119 9.44995C3.49684 9.44995 0.999756 11.4845 0.999756 14"
                     stroke="#94928E"
                     stroke-width="1.2"
                     stroke-linecap="round"
                     stroke-linejoin="round"
                 />
              </svg>
           </span>
           {{ course.enrollment_count }} {{ lms_website.__('Students') }}
        </span>
      </div>
      <h4 class="tp-course-title">
        <router-link :to="`/courses/view/${course.name}`">
          {{ clip(lms_website.__(course.title), 75) }}
        </router-link>
      </h4>
      <div class="tp-course-rating d-flex align-items-end justify-content-between">
        <div class="tp-course-rating-star">
          <p>{{ floatVale(course.avg_rating) }}<span> /5</span></p>
          <div class="tp-course-rating-icon" style="margin-top:5px;">
            <div class="course-star-rating">
              <div class="back-stars">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
              </div>
              <div class="front-stars" :style="'width:'+avg_rating_width(course.avg_rating)">
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
                <i class="fa fa-star"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="tp-course-pricing home-2">
          <span v-if="!course.paid_course">{{ lms_website.__('Free') }}</span>
          <template v-if="course.paid_course">
            <template v-if="course?.custom_course_sale_price">
              <del>{{ format_currency(course.course_price) }}</del>
              <span>{{ format_currency(course.custom_course_sale_price) }}</span>
            </template>
            <template v-else>
              <span>{{ format_currency(course.course_price) }}</span>
            </template>
          </template>
        </div>
      </div>
    </div>
    <div class="tp-course-btn home-2">
      <router-link :to="`/courses/view/${course.name}`">{{ lms_website.__('Preview this Course') }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseWidget",
  props: {
    course: {
      type: [Object],
      default: {}
    },
    cssClass: {
      type: [String],
      default: ''
    },
    cssStyle: {
      type: [String],
      default: ''
    }
  },
  setup() {
    return {
      lms_website
    }
  },
  methods: {
    format_currency(price = 0) {
      return format_currency(price).replace(/\.\d{2}$/, '');
    },
    removeZeroDecimal(amountString) {
      const amount = parseFloat(amountString.replace(/[^\d.-]/g, ''));
      if (amount % 1 === 0) {
        return `EGP ${amount.toLocaleString('en-US', {maximumFractionDigits: 0})}`;
      } else {
        return `EGP ${amount.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
      }
    },
    avg_rating_width(value) {
      if (value) {
        return `${((value / 5) * 100) + 3}%`;
      }
      return '0%';
    },
    floatVale(value, digits = 1) {
      return parseFloat(value).toFixed(digits);
    },
    clip(str, limit) {
      if (!str) return '';
      str = str.toString();
      if (str.length <= limit) {
        return str;
      }
      return str.substr(0, limit) + '...';
    }
  }
}
</script>

<style scoped>

</style>
